import React, { PureComponent } from "react";
import {
  Table,
  Button as AntdButton,
  Input,
  DatePicker,
  message,
  Row,
  Col,
} from "antd";
import { connect } from "react-redux";
import { getTranslate } from "react-localize-redux";
import * as numeral from "numeral";
import moment from "moment";
import { withActions, isBusy } from "actionware";
import { json2csv, csv2json } from "json-2-csv";
import InlineSVG from "react-inlinesvg";
import { Link } from "react-router-dom";

import {
  getApplication,
  downloadReport,
} from "../application/applicationApprovalActions";
import { getFallbackProductCode } from "../fundingLimit/fundingLimitComponents/utils";
import {
  moneyFormat,
  dateFormat,
  csvFields,
  jsonDateFormat,
  reportType,
} from "../../common/constants";
import downloadIcon from "../../assets/download_icon.svg";
import BorrowerDetails from "../borrower/borrowerDetails";

const { RangePicker } = DatePicker;
@connect(
  ({
    localize,
    applicationApproval: {
      applications: { lists, summary },
      productBorrowerMapping,
    },
  }) => ({
    translate: getTranslate(localize),
    lists,
    summary,
    productBorrowerMapping,
    loading: isBusy(getApplication),
  })
)
@withActions({ getApplication, downloadReport })
class LoanTable extends PureComponent {
  constructor() {
    super();
    this.state = {};
    this.handlePaginationChange = this.handlePaginationChange.bind(this);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleDownloadReport = this.handleDownloadReport.bind(this);
  }
  handlePaginationChange(current, size) {
    const { currentLenderId } = this.props;
    const params = {
      sort_field: "submission_date",
      sort_order: "desc",
      page: current,
      size,
      status: "approved",
      lender_id: currentLenderId,
    };
    this.props.getApplication(params);
  }

  handleTableChange(pagination, filters, sorter) {
    const { submission_date, status, ...rest } = filters;
    const sorters = {
      sort_field: sorter.field ? sorter.field : "submission_date",
      sort_order: sorter.order ? sorter.order.split("end")[0] : "desc",
    };
    const { currentLenderId } = this.props;
    const params = {
      page: pagination.current,
      size: pagination.pageSize,
      status: "approved",
      sort_field: "submission_date",
      sort_order: "desc",
      lender_id: currentLenderId,
      ...(status && status.length > 0 && { status: status[0] }),
      ...(submission_date &&
        submission_date.length > 0 && {
          submission_date_from: submission_date[0],
          submission_date_to: submission_date[1],
        }),
      ...rest,
      ...sorters,
    };
    this.setState({ changeParams: params });
    this.props.getApplication(params);
  }


  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };

  handleDownloadReport = () => {
    const { downloadReport, currentLenderId } = this.props;
    const { changeParams } = this.state;
    const today = moment().format(jsonDateFormat);
    const params = {
      report_type: reportType.borrower,
      lender_id: currentLenderId,
      status: "approved",
      ...changeParams,
    };
    downloadReport(params).then(({ data }) => {
      if (!data || Object.keys(data).length < 1) {
        return message.error("Empty report");
      }
      return csv2json(data, (err, array) => {
        const fieldInCsv = csvFields;
        return json2csv(
          array,
          (err, csv) => {
            const csvBlob = new Blob([csv], { type: "type/csv" });
            const url = window.URL.createObjectURL(csvBlob);
            const shadowLinkTag = document.createElement("a");
            shadowLinkTag.href = url;
            shadowLinkTag.download = `Pinjaman_${currentLenderId ? "(" + currentLenderId + ")_" : ""}(${today}).csv`;
            shadowLinkTag.click();
          },
          {
            keys: fieldInCsv,
          }
        );
      });
    });
  };

  getColumnFilterInput = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <AntdButton
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </AntdButton>
        <AntdButton
          onClick={() => this.handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </AntdButton>
      </div>
    ),
  });

  getColumnFilterDate = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <RangePicker
          placeholder={`Select ${dataIndex}`}
          format="YYYY-MM-DD HH:mm:ss"
          style={{ width: 188, marginBottom: 8, display: "block" }}
          onChange={(value, dateString) => {
            setSelectedKeys(dateString);
          }}
        />
        <AntdButton
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </AntdButton>
        <AntdButton
          onClick={() => this.handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </AntdButton>
      </div>
    ),
  });

  
  renderBorrowerDetailsUI = (row) => {
    return ( <BorrowerDetails row={row} /> );
  };

  render() {
    const {
      applications: { lists, totalData },
      translate,
      loading,
      role,
    } = this.props;
    const columns = [
      {
        title: translate("loanTable.submission_date"),
        dataIndex: "submission_date",
        key: "submission_date",
        ...this.getColumnFilterDate("submission_date"),
        sorter: (a, b) => a.submission_date - b.submission_date,
        render: (value) => moment(value).format(dateFormat),
      },
      {
        title: translate("loanTable.status"),
        dataIndex: "status",
        key: "status",
        render: (text) => translate(`loanTable.${text}`),
        filters: [
          { text: translate("loanTable.pending"), value: "pending" },
          { text: translate("loanTable.approved"), value: "approved" },
          { text: translate("loanTable.rejected"), value: "rejected" },
          { text: translate("loanTable.disbursed"), value: "completed" }, // in funding service, completed means disbursed
        ],
        filterMultiple: false,
      },
      {
        title: translate("loanTable.borrower_name"),
        dataIndex: "borrower_name",
        key: "borrower_name",
        render: (text, row, index) => {
          return this.renderBorrowerDetailsUI(row);
        },
      },
      {
        title: translate("loanTable.application_id"),
        dataIndex: "application_id",
        key: "application_id",
        ...this.getColumnFilterInput("application_id"),
        render: (text, row, index) => {
        return (
          <Link 
            to={{
              pathname: `/loan/details/${row.application_id}`,
              state: role === "LENDER" ? {  from: '/loan', status: row.status } : {  from: '/loan', lenderId: row.lender_id, status: row.status }
            }}
          >
            {text}
          </Link>
          );
        },
        
      },
      {
        title: translate("loanTable.product"),
        dataIndex: "product",
        key: "product",
        ...this.getColumnFilterInput("product"),
        render: (value) => value && value.toUpperCase(),
      },
      {
        title: translate("loanTable.purpose"),
        dataIndex: "purpose",
        key: "purpose",
      },
      {
        title: translate("loanTable.loan_amount"),
        dataIndex: "loan_amount",
        key: "loan_amount",
        sorter: true,
        ...this.getColumnFilterInput("loan_amount"),
        render: (value) => numeral(value).format(moneyFormat),
        align: "right",
      },
      {
        title: translate("loanTable.tenure"),
        dataIndex: "tenure",
        key: "tenure",
        sorter: (a, b) => a.tenure - b.tenure,
        render: (value) => `${value} ${translate("loanTable.day")}`,
      },
      {
        title: translate("loanTable.interest"),
        dataIndex: "interest",
        key: "interest",
        sorter: (a, b) => a.interest - b.interest,
        render: (value) => `${value}%`,
      },
      {
        title: translate("loanTable.other_fees"),
        children: [
          {
            title: translate("loanTable.admin_fee"),
            dataIndex: "admin_fee",
            key: "admin_fee",
          },
          {
            title: translate("loanTable.penalty"),
            dataIndex: "penalty",
            key: "penalty",
          },
        ],
      },
      {
        title: translate("loanTable.partner_score"),
        dataIndex: "ofin_credit_score",
        key: "ofin_credit_score",
      },
    ];

    let uniqueId = 0;
    return (
      <>
        <Row className="loan-table-header">
          <Col span={6} className="loan-table-title">
            {translate("loanTable.table_tile")}
          </Col>
          <Col span={6} offset={12} className="loan-table-btn">
            <AntdButton
              className="excel-download"
              onClick={this.handleDownloadReport}
            >
              <InlineSVG className="download-icon" src={downloadIcon} />
              {translate("loanDetailPage.ovo_admin_button_download_excel")}
            </AntdButton>
          </Col>
        </Row>
        <Table
          bordered
          columns={columns}
          dataSource={lists}
          onChange={this.handleTableChange}
          loading={loading}
          pagination={{
            total: totalData,
            showSizeChanger: true,
            defaultPageSize: 10,
            pageSizeOptions: ["10", "25", "50"],
            onShowSizeChange: this.handlePaginationChange,
          }}
          rowKey={(record) => {
            if (!record.__uniqueId) {
              record.__uniqueId = ++uniqueId;
            }
            return record.__uniqueId;
          }}
        />
      </>
    );
  }
}

export default LoanTable;
